/**
 * @file 认证企业简介
 * @author zhaomiaoyuan
 */

import React, {useEffect, useState, useCallback} from 'react';
import PropTypes from 'prop-types';

import commentSvg from '../../asset/img/userCenter/microCard/comment.svg';
import phoneSvg from '../../asset/img/userCenter/microCard/phone.svg';
import descSvg from '../../asset/img/userCenter/microCard/desc.svg';
import positionSvg from '../../asset/img/userCenter/microCard/position.svg';
import websiteSvg from '../../asset/img/userCenter/microCard/website.svg';
import rightOutlined from '../../asset/img/userCenter/microCard/right-outlined.png';
import 'swiper/components/navigation/navigation.less';

import './microCard.less';

export default function MicroCard(props) {
    const {microCard} = props;

    const setNewCompanyData = useCallback(() => {
        const phones = microCard.phones?.filter(item => item.auth_type === 1) ?? [];
        return {
            ...microCard,
            phones
        };
    }, [microCard]);

    const [companyData, setCompanyData] = useState(setNewCompanyData());

    useEffect(() => {
        const newCompanyData = setNewCompanyData();
        setCompanyData(newCompanyData);
    }, [microCard, setNewCompanyData]);

    function renderSwiper() {
        const companyAdverts = microCard?.company_adverts;
        if (!companyAdverts) {
            return null;
        }
        return <img className={'swiper'}
            src={'/api/v1/cloud/download/bos?objectName=' + companyAdverts[0]} alt=""></img>;
    }
    const renderWebsite = () => {
        // 是否有有效的企业小程序信息
        const hasValidMiniInfo = companyData.xcx_appkey && companyData.xcx_path;
        // 是否展示企业官网
        const showCompanyWebsite = (!!companyData.website || hasValidMiniInfo) ?? false;

        if (!showCompanyWebsite) {
            return null;
        }
        return (
            <div className="b-c-desc">
                <img className={'item-icon left'} src={websiteSvg} alt="" />
                <div className="desc-content" style={{color: '#3388ff'}}>
                    {companyData.website || '官方网站'}
                </div>
                <div className="item-icon right">
                    <img width={16} src={rightOutlined}></img>
                </div>
            </div>
        );
    };
    const formatAddress = () => {
        const address = companyData.detailed_loc;
        if (address) {
            const tmp = address[1].split(',');
            return tmp[0] === tmp[1] ? tmp[0] : tmp[0] + tmp[1];
        }
        return '';
    };
    const renderAddress = () => {
        if (!(companyData.detailed_loc || companyData.detailed_addr)) {
            return null;
        }
        const address = formatAddress();
        const completeAddress = address + companyData.detailed_addr;
        return (
            <div className="b-c-desc">
                <img className={'item-icon left'} src={positionSvg} alt="" />
                <div className="desc-content">{completeAddress}</div>
                <div className="item-icon right">
                    <img width={16} src={rightOutlined}></img>
                </div>
            </div>
        );
    };
    const renderCompanyIntro = () => {
        const companyIntro = companyData.company_introduction;
        if (!companyIntro) {
            return null;
        }
        return (
            <div className="b-c-desc">
                <img className={'item-icon left'} src={descSvg} alt="" />
                <div className="desc-content">{companyIntro}</div>
                <div className="item-icon right">
                    <img width={16} src={rightOutlined}></img>
                </div>
            </div>
        );
    };
    const renderAssessment = () => {
        const assessment = companyData.assessment || {}; // 评价信息
        if (assessment.total === 0) {
            return null;
        }
        return (
            <div>
                <div className="official-phone-tag">全部&nbsp;{assessment.total}</div>
                <div className="official-phone-tag">电话接通快&nbsp;{assessment.r_count}</div>
                <div className="official-phone-tag">号码准确&nbsp;{assessment.a_count}</div>
                <div className="official-phone-tag">问题得到解决&nbsp;{assessment.s_count}</div>
            </div>
        );
    };
    const onlineInfo = () => {
        const openInfo = (companyData.open_info && companyData.open_info) || [];
        let result = [];
        if (openInfo.length === 0) {
            result = ['全天'];
        } else {
            result = openInfo.map(v => {
                return v.day_range + '：' + v.open_time + '-' + v.close_time;
            });
        }
        return result;
    };
    const renderOnline = () => {
        const time = onlineInfo();
        return (
            <div className="b-c-desc">
                <div className="desc-content" style={{color: '#999', width: '90%'}}>
                    接通时间：{time}
                </div>
                <div className="item-icon right">
                    <img width={16} src={rightOutlined}></img>
                </div>
            </div>
        );
    };

    const renderPhoneList = () => {
        const phonesData = companyData.phones;

        if (!phonesData?.length) {
            return;
        }
        return phonesData.map(item => {
            return (
                <div key={item.phone} className="item-con-2">
                    <div>
                        <div className="item-phone">{item.phone}</div>
                        {item.phone_display && <div className="item-title">{item.phone_display}</div>}
                    </div>
                    <img className="item-icon" width={16} src={phoneSvg} alt="" />
                </div>
            );
        });
    };

    const renderOnlineFAQ = () => {
        if (companyData.qa === 1) {
            return (
                <div className="main-online-faq">
                    <div className="main-online-faq-title">问企业</div>
                    <div className="main-online-faq-content">
                        有问题的话，
                        <a href="javascript:void(0)">问问企业</a>
                        吧～
                    </div>
                </div>
            );
        }
    };
    return (
        <div className="preview-h5 preview-style">
            <div className="preview-swan-content">
                {renderSwiper()}
                <div className="card-main">
                    <div className="card-main-abs">
                        <div className="main-pd">
                            <div>
                                <div className="b-c-name">{companyData.company_name}</div>
                                {companyData.gold_phone_company === 1 && <div className="card-tag">金牌联通企业</div>}
                                {companyData.gold_phone_service === 1 && <div className="card-tag">优质电话服务</div>}
                                {renderWebsite()}
                                {renderAddress()}
                                {renderCompanyIntro()}
                            </div>
                        </div>
                        <div className="main-phone-section">
                            <div className="official-phone-title">
                                <div className="official-phone-title-text">企业官方号码</div>
                                <div className="comment">
                                    <img className={'item-icon comment-icon'} src={commentSvg} alt="" />
                                    评价
                                </div>
                            </div>
                            {renderAssessment()}
                            {renderOnline()}
                            {renderPhoneList()}
                        </div>
                        {renderOnlineFAQ()}
                    </div>
                </div>
            </div>
        </div>
    );
}

MicroCard.propTypes = {
    history: PropTypes.any,
    microCard: PropTypes.any
};
